import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmarCancelarModalComponent } from '../confirmar-cancelar-modal/confirmar-cancelar-modal.component';
import { IonicModule } from '@ionic/angular';
import { AvisoModalComponent } from '../aviso-modal/aviso-modal.component';
import { ConfirmaInformacoesParaEnvioModalComponent } from '../confirma-informacoes-para-envio-modal/confirma-informacoes-para-envio-modal.component';
import { PipeModule } from 'src/app/pipe/pipe/pipe.module';
import {
    MatDialogModule,
} from '@angular/material/dialog';
import { InformativoVersaoModalComponent } from 'src/app/component/informativo-versao-modal/informativo-versao-modal.component';

@NgModule({
    declarations: [
        ConfirmarCancelarModalComponent,
        ConfirmaInformacoesParaEnvioModalComponent,
        AvisoModalComponent,
        InformativoVersaoModalComponent,
    ],
    imports: [CommonModule, IonicModule, PipeModule, MatDialogModule],
    exports: [
        ConfirmarCancelarModalComponent,
        ConfirmaInformacoesParaEnvioModalComponent,
        AvisoModalComponent,
        InformativoVersaoModalComponent,
    ],
    entryComponents: [
        ConfirmarCancelarModalComponent,
        ConfirmaInformacoesParaEnvioModalComponent,
        AvisoModalComponent,
        InformativoVersaoModalComponent,
    ],
})
export class ModalModule {}
